import React from 'react';

const Header: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <nav className="nav container">
        <a href="#inicio" className="logo">CasaDirecta</a>
        <ul className="nav-links">
          <li><a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>Inicio</a></li>
          <li><a href="#beneficios" onClick={(e) => { e.preventDefault(); scrollToSection('beneficios'); }}>Beneficios</a></li>
          <li><a href="#proceso" onClick={(e) => { e.preventDefault(); scrollToSection('proceso'); }}>Cómo Funciona</a></li>
          <li><a href="#formulario" onClick={(e) => { e.preventDefault(); scrollToSection('formulario'); }}>Vende tu Casa</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;